export default __webpack_public_path__ + "static/media/night.f2466264.jpg";